import ItemListPage from "./ItemListPage";

export default function Upcoming() {
  return (
    <ItemListPage titleKey="nav.upcoming" subtitleKey="dashboard.upcomingSubtitle" testid="upcoming-page" status="upcoming" />
  );
}
